import { Box, Grid } from '@material-ui/core';
import { useEffect } from 'react';
import ImProductOutputManagementCart from './ImProductOutputManagementCart';
import ImProductOutputManagementHeader from './ImProductOutputManagementHeader';
import ImProductOutputManagementProductList from './ImProductOutputManagementProductList';
import { productsOutputManagementStore } from 'stores/productsOutputManagement.store';

export default function ImProductOutputManagment() {
  const { reset } = productsOutputManagementStore((state: any) => ({ reset: state.reset }));
  useEffect(() => {
    return () => {
      reset();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Grid container>
      <Grid item md={6}>
        <ImProductOutputManagementProductList />
      </Grid>
      <Grid item md={6}>
        <Box display="column">
          <Box ml={1}>
            <ImProductOutputManagementHeader />
          </Box>
          <Box mt={1} ml={1}>
            <ImProductOutputManagementCart />
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
}
